import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isPro: false,
  isMarketing: false,
};

export const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setIsPro: (state, action) => {
      state.isPro = action.payload;
    },
    setIsMarketing: (state, action) => {
      state.isMarketing = action.payload;
    },
  },
});

export const { setIsPro, setIsMarketing } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
